import {useDispatch} from "react-redux";
import {useLicenceSelector} from "../../../../redux/reducers/licenceReducer";
import {filterLicences, clearLicencesFilter} from "../../../../redux/actions/licenceActions";
import {useEffect} from "react";

export const useController = () => {
    const dispatch = useDispatch();

    useEffect(() => {
        return (() => {
            dispatch(clearLicencesFilter());
        })
    }, []);

    const {filteredLicences} = useLicenceSelector();

    return {
        filteredLicences,
        filterLicences: (filterValues) => {
            dispatch(filterLicences(filterValues))
        },
    };
};